import { cloneDeep, times } from 'lodash';
import createTaskType from '../../createTaskType';
import PersonalIntroductionsEditor from './Editor';

export default createTaskType({
    id: 'personal_introductions',
    label: 'Personal Introductions',
    skill: 'listening',
    v2: true,
    hasRubric: true,

    editor: PersonalIntroductionsEditor,
    createItemsTemplate: () => times(6, index => ({
        is_example: index === 0,
        background_image: '',
        stimulus_text: '',
        audio_id: '',
        answers: times(3, i => ({
            key_text: '',
            is_correct_answer: false,
        })),
        ...(index === 0 && {
            rubric_id: '',
        }),
    })),

    convertToUploadFormat(task, { isNew }) {
        task = cloneDeep(task);

        task.items = task.items.map(i => {
            i.answers = i.answers.map(a => {
                delete a.coordinates;
                return a;
            });
            return i;
        });

        return task;
    },

    getKeys: (item) => {
        return item.answers
            .filter(x => x.is_correct_answer)
            .map((x, idx) => `Option ${'ABC'[idx]} - ${x.key}`);
    }
});